// extracted by mini-css-extract-plugin
module.exports = {"userContent":"UserProfile_userContent__1yXOC","descriptionContainer":"UserProfile_descriptionContainer__1tvUM","name":"UserProfile_name__2uP_Z"};